module.exports = __webpack_public_path__ + "SourceSansPro-Italic.bd7adef6f076d52b2837.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Italic.woff2
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Italic.woff2
// module chunks = styles